import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, enviarSolicitacaoMP } from './types';

export const INITIAL_STATE: enviarSolicitacaoMP = {
	status: 0,
	data: {
		protocolo: '',
	},
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): enviarSolicitacaoMP {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ENVIAR_SOLICITACAO_MP_REQUEST: {
				break;
			}

			case Types.ENVIAR_SOLICITACAO_MP_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.ENVIAR_SOLICITACAO_MP_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.LIMPAR_SOLICITACAO_MP: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
